import { render } from "./BackGroundRefresh.vue?vue&type=template&id=4ac555eb&scoped=true"
import script from "./BackGroundRefresh.vue?vue&type=script&lang=js"
export * from "./BackGroundRefresh.vue?vue&type=script&lang=js"

import "./BackGroundRefresh.vue?vue&type=style&index=0&id=4ac555eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac555eb"]])

export default __exports__